module.exports = __webpack_public_path__ + "img/qr-scan-2.5ab4ef78.png";